import EditProfilePublic from '../components/profile/EditProfilePublic'
import EditProfilePrivate from '../components/profile/EditProfilePrivate'
import EditProfileHelp from '../components/helps/EditProfileHelp';

const EditProfile = () => {

    return (
        <>
            <EditProfilePublic />
            <EditProfilePrivate />
            <EditProfileHelp />
        </>
    )
}

export default EditProfile